import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { fetchHandshake } from '@/services/handshake';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';

import MapLocations from '@/components/branches/MapLocations';
import BranchInfo from '@/components/branches/BranchInfo';
import BreadCrumb from '@/components/global/buttons/BreadCrumb';
import Map from '@/components/branches/Map';
import { getBranches } from '@/services/product';
import Seo from '@/components/seo';
import { useRouter } from 'next/router';
import MapIcon from '@/components/icons/map-icon';

const Index = ({ data: ApiData = [], groupedByRegion }) => {
  const { t } = useTranslation('common');
  const {locale} = useRouter()
  const [map, setMap] = useState(null);
  const [branchInView, setBranchInView] = useState(ApiData?.at(0));
  const allBranches = Object.values(groupedByRegion)?.flat() || [];
  const [data, setData] = useState(allBranches);
  console.log('data branches', data)

  if(data?.length == 0) {
    return <div className='flex flex-col gap-4 h-[70vh] items-center justify-center'>
      <MapIcon className='size-64' />
      <h1 className='text-center text-2xl font-bold'>
        {locale === 'ar' ? 'لا توجد فروع متاحة' : 'No Branches Found'}</h1>
    </div>
  }

  return (
    <>
      <Seo title={t('Our Branches')} />
      <BreadCrumb data={[t('Our Branches')]} />
      <section className='mx-auto my-3 sm:my-5'>
        <div className='mb-4 flex flex-wrap justify-between gap-4 max-sm:flex-col sm:mb-8 sm:items-center'>
          <h1 className='text-[13px] font-bold sm:text-3xl sm:font-semibold'></h1>
          <div className='flex items-center gap-2'>
            <MapLocations
              t={t}
              data={groupedByRegion}
              branchInView={branchInView}
              setBranches={setData}
              setBranchInView={setBranchInView}
              map={map}

            />
          </div>
        </div>
        <div className='grid grid-cols-12 sm:gap-4'>
          <div className='pr-3 red-scrollbar gray-scroll order-2 col-span-full max-h-[80vh] overflow-y-auto *:mb-3 max-lg:gap-4 max-lg:overflow-x-auto lg:order-1 lg:col-span-4'>
          {data.map((info, i) => (
              <BranchInfo
              key={i}
              t={t}
              info={info}
              map={map}
              branchInView={branchInView}
              setBranchInView={setBranchInView}
            />
            ))}
          </div>
          <div className='order-1 col-span-full lg:order-2 lg:col-span-8'>
            <Map
              data={data}
              setMap={setMap}
              branchInView={branchInView}
              setBranchInView={setBranchInView}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Index;

export async function getServerSideProps({ locale, req, res }) {
  const handshake = await fetchHandshake({ locale, req, res });
  const { data, error } = await getBranches(handshake);
  if (error) {
    return {
      props: {},
    };
  }
  
  const groupedByRegion = data?.data?.reduce((acc, cur) => {
    const region = cur.city;
    if (!acc[region]) {
      acc[region] = [];
    }
    acc[region].push(cur);
    return acc;
  }, {});

  return {
    props: {
      data: data?.data || [],
      groupedByRegion: groupedByRegion || {},
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}
